export const getFirebaseLoginErrorMessage = (error: any): string => {
  const errorCode = error.code;

  switch (errorCode) {
  case 'auth/user-not-found':
    return 'No account found with this email address. Please check your email or sign up.';
  case 'auth/wrong-password':
    return 'Incorrect password. Please try again.';
  case 'auth/invalid-email':
    return 'Please enter a valid email address.';
  case 'auth/user-disabled':
    return 'This account has been disabled. Please contact support.';
  case 'auth/too-many-requests':
    return 'Too many failed login attempts. Please try again later.';
  case 'auth/network-request-failed':
    return 'Network error. Please check your connection and try again.';
  case 'auth/invalid-credential':
    return 'Invalid email or password. Please check your credentials and try again.';
  default:
    return 'An error occurred while signing in. Please try again.';
  }
};

export const getFirebaseSignupErrorMessage = (error: any): string => {
  const errorCode = error.code;

  switch (errorCode) {
  case 'auth/email-already-in-use':
    return 'This email address is already registered. Please try logging in instead.';
  case 'auth/weak-password':
    return 'Please choose a stronger password.';
  case 'auth/invalid-email':
    return 'Please enter a valid email address.';
  case 'auth/operation-not-allowed':
    return 'Account creation is currently disabled. Please contact support.';
  case 'auth/too-many-requests':
    return 'Too many failed attempts. Please try again later.';
  case 'auth/network-request-failed':
    return 'Network error. Please check your connection and try again.';
  default:
    return 'An error occurred while creating your account. Please try again.';
  }
};
